/**
 * The tabs round's "Waiting on others" tab (`…/quality-copilot/waiting`) is
 * a filter on Triage now (waiting filter round): an old link or bookmark
 * lands on Triage with the filter on, keeping any `who=` it carried.
 */
import { Navigate, useSearchParams } from 'react-router-dom';

export default function WaitingRedirect() {
  const [params] = useSearchParams();
  const next = new URLSearchParams({ show: 'waiting' });
  const who = params.get('who');
  if (who) next.set('who', who);
  // `..` from the `waiting` route is the door (React Router resolves by
  // route level), whose index is Triage.
  return <Navigate to={{ pathname: '..', search: `?${next.toString()}` }} replace />;
}
